import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import 'react-widgets/dist/css/react-widgets.css';
import Loader from 'react-loader-spinner';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

var monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];

class EscalationSessions extends Component {
    constructor() {
        super();
        this.state = {
            successResp: true,
            showLogTable: false,
            data: [],
            utData: [],
            selectedDate: new Date(),
            selectedSupportUser: '',
            loadedSUpportUserName: null
        }
        this.supportUserName = "";
        this.supportUserList = [];
    }

    componentDidMount() {
        var thisController = this;

        setTimeout(() => {
            thisController.state.utData = [];
            thisController.state.showLogTable = false;
            //thisController.fetchSupportUserName();
            thisController.fetchConversationSupervisionInfosApi();
            thisController.fetchSupportTeamDataApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            thisController.state.utData = [];
            thisController.state.showLogTable = false;
            thisController.projectId = event.projectId;
           // thisController.fetchSupportUserName(event.projectId);
            thisController.fetchConversationSupervisionInfosApi(event.projectId);
            thisController.fetchSupportTeamDataApi(event.projectId);

        });
    }
    fetchUtterancesApi = (id) => {
        var utteranceController = this;

        $.ajax({
            url: "/api/utterances/",
            async: false,
            method: 'GET',
            data: { conversationId: id },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token"), },
            success: function (res) {
                if (res.success === true) {
                    utteranceController.setState({
                        utData: res.result,
                        successResp: true
                    });
                } else {
                    utteranceController.notifyFailToCreate();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }

    fetchSupportUserName = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var thisController = this;

        var selectedDate = thisController.state.selectedDate;
        selectedDate = selectedDate.getDate() + "-" + monthNames[parseInt(selectedDate.getMonth())] + "-" + selectedDate.getFullYear();
        selectedDate = btoa(selectedDate);
        $.ajax({
            url: "/api/conversation-supervision-info",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId,
                "date": selectedDate
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    var ele3 = document.getElementById("supportUserName");

                    if (res.result.length > 0) {
                        var loadedName = res.result;
                        thisController.setState({ loadedSUpportUserName: loadedName });

                        var numberOfUsers = loadedName.length;
                        var uniqueUserNamesloaded = [];
                        for (var i = 0; i < numberOfUsers; i++) {
                            uniqueUserNamesloaded[i] = loadedName[i]['supportUserName']
                        }
                        let uNames = [...new Set(uniqueUserNamesloaded)]

                        if (ele3 != null) {
                            if (ele3.value != "") {
                                ele3.innerHTML = "";
                            }
                            ele3.innerHTML = ele3.innerHTML + '<option value="All">All</option>';

                            for (var i = 0; i < uNames.length; i++) {
                                ele3.innerHTML = ele3.innerHTML + '<option value="' + uNames[i]
                                    + '">' + uNames[i] + '</option>';

                            }

                        }
                    } else {
                        if (ele3 != null) {
                            if (ele3.value != "") {
                                ele3.innerHTML = "";
                            }
                            ele3.innerHTML = ele3.innerHTML + '<option value="All">All</option>';

                        }
                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }
    fetchConversationSupervisionInfosApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }

        var escSessionsCom = this;
        var selectedDate = escSessionsCom.state.selectedDate;
        selectedDate = selectedDate.getDate() + "-" + monthNames[parseInt(selectedDate.getMonth())] + "-" + selectedDate.getFullYear();
        selectedDate = btoa(selectedDate);

        var supportUserListTag = document.getElementById("supportUserName");
        var unique;
        $.ajax({
            url: "/api/conversation-supervision-info",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId,
                "date": selectedDate
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    escSessionsCom.state.data = res.result;
                    if (res.result.length > 0) {
                        escSessionsCom.supportUserList = res.result.supportUserName;
                    }
                    for (var i = 0; i < res.result.length; i++) {
                        const startTime = res.result[i].startTime == 0 ? 0 : new Date(res.result[i].startTime)
                        const endTime = res.result[i].endTime == 0 ? 0 : new Date(res.result[i].endTime)
                        escSessionsCom.state.data[i].startTime = startTime == 0 ? "-" : startTime.getHours() + ":" + startTime.getMinutes() + ":" + startTime.getSeconds();
                        escSessionsCom.state.data[i].endTime = endTime == 0 ? "-" : endTime.getHours() + ":" + endTime.getMinutes() + ":" + endTime.getSeconds();
                    }
                    escSessionsCom.state.successResp = true;
                    escSessionsCom.setState(escSessionsCom.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    refreshData = () => {
        this.fetchConversationSupervisionInfosApi()
    }

    onDateChange = (date) => {
        this.state.selectedDate = date;
        this.state.showLogTable = false;
        this.setState(this.state);
        this.fetchSupportTeamDataApi();
        this.fetchConversationSupervisionInfosApi();
    }
    ViewLogInfo = (id) => {

        this.fetchUtterancesApi(id);
        this.setState({
            showLogTable: true
        })
        // this.setState({
        //   text: this.state.value
        // });
    }
    supportUserNameListHandleChange = (e) => {
        this.state.showLogTable = false;
        this.setState(this.state);
        if (e.target.value == "All") {
            this.fetchConversationSupervisionInfosApi();
        } else {
            this.fetchConversationSupervisionInfosBySupportUserNameApi(e.target.value);
        }
    }
    fetchConversationSupervisionInfosBySupportUserNameApi(e) {

        var selectSupportUserName = e;
        var conversationInFoByName = this;
        var selectedDate = conversationInFoByName.state.selectedDate;
        selectedDate = selectedDate.getDate() + "-" + monthNames[parseInt(selectedDate.getMonth())] + "-" + selectedDate.getFullYear();
        selectedDate = btoa(selectedDate);
        $.ajax({
            url: "/api/conversation-based-on-name",
            async: false,
            method: 'GET',
            data: {
                "supportUserName": selectSupportUserName,
                "projectId": localStorage.getItem('currentProjectId'),
                "date": selectedDate
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    conversationInFoByName.state.data = res.result;
                    for (var i = 0; i < res.result.length; i++) {
                        const startTime = res.result[i].startTime == 0 ? 0 : new Date(res.result[i].startTime)
                        const endTime = res.result[i].endTime == 0 ? 0 : new Date(res.result[i].endTime)
                        conversationInFoByName.state.data[i].startTime = startTime == 0 ? "-" : startTime.getDate() + "/" + parseInt(startTime.getMonth() + 1) + "/" + startTime.getFullYear() + " " + startTime.getHours() + ":" + startTime.getMinutes() + ":" + startTime.getSeconds();
                        conversationInFoByName.state.data[i].endTime = endTime == 0 ? "-" : endTime.getDate() + "/" + parseInt(endTime.getMonth() + 1) + "/" + endTime.getFullYear() + " " + endTime.getHours() + ":" + endTime.getMinutes() + ":" + endTime.getSeconds();
                    }
                    conversationInFoByName.state.successResp = true;
                    conversationInFoByName.setState(conversationInFoByName.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }
    fetchSupportTeamDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var teamController = this;
        $.ajax({
            url: "/api/project-membership-support-team",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,

            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                teamController.state.successResp = true;
                teamController.setState(teamController.state);
                if (res.success === true) {
                    if (res.result.length > 0) {
                    var loadedData = res.result;

                    teamController.setState({ supportUserName: loadedData });
                    var numberOfUsers = loadedData.length;
                    var ele3 = document.getElementById("supportUserNameDropDown");
        
                    if (ele3 != "") {
                      if (ele3 != null) {
                        ele3.innerHTML = "";
                        ele3.innerHTML = ele3.innerHTML + '<option value="All">All</option>';

        
                        for (var i = 0; i < numberOfUsers; i++) {
                          ele3.innerHTML = ele3.innerHTML + '<option value="' + loadedData[i].userName+ '">' + loadedData[i].userName + '</option>';
                        }
                      }
                    }
                }} else {
                    if (ele3 != null) {
                        if (ele3.value != "") {
                            ele3.innerHTML = "";
                        }
                        ele3.innerHTML = ele3.innerHTML + '<option value="All">All</option>';

                    }
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        });
    }

    render() {
        const { data } = this.state;
        const columns1 = [

            {

                Header: '',
                minWidth: 17,
                textAlign: 'screenLeft',
                accessor: 'text',
                sortable: false,
                cellStyle: { border: 'none' },
                headerStyle: { marginTop: '-10px' },
                Cell: props =>
                (

                    <div class="card-body chat_body log_one" style={{ display: (this.state.showLogTable) && (props.original.text != "") ? 'block' : 'none' }}>
                        <div className={(props.original.incoming == false) ? "direct-chat-msg" : "direct-chat-msg right "}>
                            <div className={(props.original.incoming == false) ? "direct-chat-text chat_left textarea" : "direct-chat-text chat_right textarea"}
                                style={{
                                    display: props.original.id != "" || props.original.id != undefined ||
                                        props.original.id != null || props.original.text != null ? "block" : "none",
                                    marginTop: "5px", width: "auto", height: "auto",
                                    backgroundColor: props.original.incoming == false ? "#ead5d5" : "#e1e1f5",
                                    marginTop: '-10px', borderBottom: 'none',
                                    textAlign: props.original.incoming == false ? "left" : "right",
                                }}>

                                <font
                                    id={"text" + props.index}
                                    readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false}>{props.original.text}
                                </font>
                            </div>
                        </div>
                    </div>

                )
            },
        ]
        const columns = [
            {
                Header: <b style={{ fontSize: '12px' }}>Customer Name</b>,
                textAlign: 'screenLeft',
                accessor: 'customerName',

                sortable: false,
                Cell: props => {
                    return (
                        (<div
                            Align="left" className="input"
                            style={{
                                padding: '8px', width: '90%', borderBottom: 'none',
                                border: 'none', paddingLeft: '2px'
                            }}
                            suppressContentEditableWarning
                            contentEditable={false}
                            type="text">{props.original.customerName}</div>)
                    )
                },
            }, {
                Header: <b style={{ fontSize: '12px' }}>Customer Contact No</b>,
                accessor: 'customerContactNo',
                sortable: false,

                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '90%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.customerContactNo}</div>)
                },
            },
            {
                Header: < b style={{ fontSize: '12px' }}>Support User Name</b>,
                 accessor: 'supportUserName',
                sortable: false,

                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '90%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.supportUserName}</div>)
                },
            },
            {
                Header: <b style={{ fontSize: '12px' }}>Start Time</b>,
                accessor: 'startTime',
                sortable: false,

                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '90%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.startTime}</div>)
                },
            }, {
                Header: <b style={{ fontSize: '12px' }}>End Time</b>,
                accessor: 'endTime',
                sortable: false,

                Cell: props => {
                    return (<div
                        Align="left" className="input"
                        style={{
                            padding: '8px', width: '90%', borderBottom: 'none',
                            border: 'none', paddingLeft: '2px'
                        }}
                        suppressContentEditableWarning
                        contentEditable={false}
                        type="text">{props.original.endTime}</div>)
                },
            }, {
                Header: <b style={{ fontSize: '12px' }}>Action</b>,
                accessor: 'action',

                Cell: props => (
                    <div id="action">
                        <button onClick={() => {
                            this.ViewLogInfo(props.original.conversationId);
                        }}
                            className="btn2 table-action-button "
                            title="View conversation"
                            style={{ borderRadius: '4px' }}>
                            View Log
                        </button>



                    </div>), width: 100
            }
        ]


        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.successResp}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />

                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    <style media="screen" dangerouslySetInnerHTML={{ __html: "\n    .card-footer {\n      background-color: transparent;\n      padding: 0.75rem 0.25rem;\n    }\n\n    .logtable tbody td:last-child{\n      width: 150px;\n    }\n\n    .logTableBox{\n      overflow: auto !important;\n    }\n  " }} />
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="./assets/css/react.table.border.css" />
                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    {/* <div className="wrapper"> */}
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | BackEnd Api </title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    {/* ----new style------------------------------- */}
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                    <link rel="stylesheet" href="dist/css/adminlte.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-4">
                                <h6 className="nav-item" style={{
                                    color: '#282a65', marginLeft: '1%'

                                }}>Supervisors' Escalation Sessions</h6>
                            </div>
                            {/* refresh button*/}
                            <div className="col-sm-8">
                                <label style={{ marginLeft: '15%' }}>Show Session for</label>
                                <select
                                    id="supportUserNameDropDown" className="supportUserName"
                                    //value={this.state.loadedSUpportUserName}
                                    onChange={this.supportUserNameListHandleChange}
                                    style={{
                                        width: '30%', height: '30px', borderRadius: '4px',
                                        backgroundColor: '#F9F9FB',
                                        marginLeft: '16px'

                                    }} >

                                </select>
                                <div className="d-flex flex-row-reverse pt-2" style={{ marginTop: '-7%' }}>

                                    <button onClick={this.refreshData} className="btn action-button"
                                        title="Refresh">
                                        <img src="./assets/images/refresh_white_24dp.png"></img>
                                    </button>
                                    <div align='right'>
                                        <DatePicker
                                            id="date"
                                            selected={this.state.selectedDate}
                                            onChange={this.onDateChange}
                                            dateFormat="dd/MM/yyyy">
                                        </DatePicker>

                                    </div>
                                    <label style={{ margin: '2%' }}>on</label>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row" >
                                <div className="col-lg-6">
                                    <div className="card"  >
                                        <ReactTable
                                            data={data}
                                            columns={columns}
                                            defaultPageSize={5}
                                            pageSizeOptions={[5, 10, 15]}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-6'>

                                    <div className="card" style={{ height: "454px" }}>
                                        <div class="table-responsive">
                                            <ReactTable id='reactTable'
                                                data={this.state.utData}
                                                columns={columns1}
                                                showPagination={false}
                                                pageSize={this.state.utData.length <= 15 ? 15 : this.state.utData.length}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )

    }
}

export default EscalationSessions;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/audit/EscalationSessions.js